import get from 'lodash/get'
import merge from 'lodash/merge'
import process from 'process'

import { getDefaultConfig } from './default'
import { getConfigDevelopment } from './development'

type Merge<T, K> = Omit<T, keyof K> & K

type ConfigDevelopment = ReturnType<typeof getConfigDevelopment>
type DefaultConfig = ReturnType<typeof getDefaultConfig>
type DefaultConfigPath = keyof DefaultConfig

type MergedConfig = Merge<DefaultConfig, ConfigDevelopment>
type MergedConfigPath = keyof MergedConfig

/**
 * Класс конфигурации.
 *
 * Используется для конфигурации всего приложения. Как для клиента, так и для сервера.
 */
export class Config<T extends object> {
  private defaultConfig: DefaultConfig
  private envConfig: ConfigDevelopment
  private mergedConfig: Merge<DefaultConfig, ConfigDevelopment>

  public readonly get:
    | typeof this.getKeyConfig
    | typeof this.getKeyConfigDevelop

  constructor(configOverrides: T) {
    this.defaultConfig = getDefaultConfig(configOverrides)
    this.envConfig = getConfigDevelopment(configOverrides)
    this.mergedConfig = merge({}, this.defaultConfig, this.envConfig)

    this.get =
      this.defaultConfig.configEnv === 'development'
        ? this.getKeyConfigDevelop.bind(this)
        : this.getKeyConfig.bind(this)
  }

  private getKeyConfig<T extends DefaultConfigPath>(path: T): DefaultConfig[T] {
    // eslint-disable-next-line ts/no-unsafe-return
    return get(this.defaultConfig, path)
  }

  private getKeyConfigDevelop<T extends MergedConfigPath>(
    path: T,
  ): MergedConfig[T] {
    // eslint-disable-next-line ts/no-unsafe-return
    return get(this.mergedConfig, path)
  }
}

/**
 * Объект конфигурации.
 *
 * ! Не используйте на клиенте !
 *
 * Этот объект конфигурации используется для настройки nuxt и его модулей. На клиенте будет всегда возаращаться дефолтная конфигурация, так как на клиенте нет process.env.
 *
 * Для доступа к конфигурации со стороны клиента используйте `gaApp.config.get(...)`
 */
export const config = new Config(process.env)
